
import { computed, defineComponent, reactive } from 'vue';
import { IOption } from '@/core/models/AntDesign/IOption';
import { useTelaBase } from '@/core/composables/TelaBase';
import ServicoCaracteristica from '@/servicos/Cadastros/Produtos/ServicoCaracteristica';

export default defineComponent({
  name: 'SelecionarTipoCaracteristica',
  props: {
    varias: {
      type: Boolean,
      default: false,
    },
    codigoSelecionado: {
      type: Number || undefined,
    },
    codigosSelecionados: {
      type: Array as () => number[],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Selecione',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:codigoSelecionado', 'update:codigosSelecionados', 'change'],
  setup(props, { emit }) {
    const { montaOpcoesComListaItemGenerico } = useTelaBase();

    const state = reactive({
      listaTipoCaracteristica: [] as IOption[],
    });

    (async () => {
      const listaTipoCaracteristica = await new ServicoCaracteristica().obterListaTipoCaracteristica();
      state.listaTipoCaracteristica = montaOpcoesComListaItemGenerico(listaTipoCaracteristica);
    })();

    function obterTipoCaracteristica():any {
      if (props.codigoSelecionado !== undefined) {
        if (props.codigoSelecionado > 0) {
          return props.codigoSelecionado;
        }
        return undefined;
      }
      return props.codigoSelecionado;
    }

    const computedCodigoSelecionado = computed({
      get: () => obterTipoCaracteristica(),
      set: (val: number) => {
        emit('update:codigoSelecionado', val);
      },
    });

    const computedCodigosSelecionados = computed({
      get: () => props.codigosSelecionados,
      set: (val: number[]) => {
        emit('update:codigosSelecionados', val);
      },
    });

    function change() {
      emit('change', props.varias ? props.codigosSelecionados : props.codigoSelecionado);
    }

    return {
      props,
      state,
      computedCodigoSelecionado,
      computedCodigosSelecionados,
      change,
    };
  },
});
